import { Helmet } from "react-helmet-async";
export const homePageHelmet = ()=>{
    return <Helmet>
  <title>AFRIYOFA | Empowering African Youth Farmers</title>
  <meta
    name="description"
    content="Join thousands of young African farmers building sustainable agricultural businesses and creating positive change in their communities. Your journey starts here."
  />
  <link rel="canonical" href="https://rwampsyouthfarmers.com/" />

  {/* Open Graph */}
  <meta property="og:title" content="AFRIYOFA | Empowering African Youth Farmers" />
  <meta
    property="og:description"
    content="Join thousands of young African farmers building sustainable agricultural businesses and creating positive change in their communities."
  />
  <meta property="og:url" content="https://rwampsyouthfarmers.com/" />
  <meta property="og:type" content="website" />
</Helmet>

}

export const aboutPageHelmet = ()=>{
    return <Helmet>
  <title>About AFRIYOFA | African Youth Farmers Network</title>
  <meta
    name="description"
    content="Learn about AFRIYOFA’s mission to empower African youth farmers through innovation, training, agribusiness support, and sustainable farming practices."
  />
  <link rel="canonical" href="https://rwampsyouthfarmers.com/about" />

  <meta property="og:title" content="About AFRIYOFA" />
  <meta
    property="og:description"
    content="AFRIYOFA empowers young African farmers to build profitable and sustainable agricultural businesses."
  />
</Helmet>

}

export const blogPageHelmet = ()=>{
    return <Helmet>
  <title>AFRIYOFA Blog | Stories & Insights from African Youth Farmers</title>
  <meta
    name="description"
    content="Read stories, insights, and updates from African youth farmers, agripreneurs, and agricultural innovators across the continent."
  />
  <link rel="canonical" href="https://rwampsyouthfarmers.com/blog" />

  <meta property="og:title" content="AFRIYOFA Blog" />
  <meta
    property="og:description"
    content="Stories and insights from African youth farmers and agribusiness leaders."
  />
</Helmet>

}

export const contactPageHelmet = ()=>{
    return <Helmet>
  <title>Contact AFRIYOFA | Get in Touch with African Youth Farmers</title>
  <meta
    name="description"
    content="Contact AFRIYOFA to partner, collaborate, or learn more about empowering African youth farmers and sustainable agriculture initiatives."
  />
  <link rel="canonical" href="https://rwampsyouthfarmers.com/contact" />

  <meta property="og:title" content="Contact AFRIYOFA" />
  <meta
    property="og:description"
    content="Get in touch with AFRIYOFA to support African youth farmers and agribusiness innovation."
  />
</Helmet>

}


export const portfolioPageHelmet = ()=>{
    return <Helmet>
  <title>AFRIYOFA Portfolio | Youth-Led Agricultural Projects</title>
  <meta
    name="description"
    content="Explore AFRIYOFA’s portfolio of youth-led agricultural projects, success stories, and community-driven farming initiatives."
  />
  <link rel="canonical" href="https://rwampsyouthfarmers.com/portfolio" />

  <meta property="og:title" content="AFRIYOFA Portfolio" />
  <meta
    property="og:description"
    content="Youth-led agricultural projects and success stories from across Africa."
  />
</Helmet>

}